
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import FieldValidationMixin from '../../FieldValidationMixin.vue'
import Hint from '../Hint.vue'
import FieldContainer from './FieldContainer.vue'
@Component({
  components: {
    Hint,
    FieldContainer
  }
})
export default class CharField extends FieldValidationMixin {
  @Prop({ default: null }) label!: string
  @Prop({ default: '' }) value!: string
  @Prop({ default: '' }) error!: string
  @Prop({ default: '' }) placeHolder!: string
  @Prop({ default: false }) required!: boolean
  @Prop({ default: false }) readOnly!: boolean
  @Prop({ default: false }) isDisabled!: boolean
  @Prop({ default: null }) charLimit!: number
  @Prop({ default: false }) charLimitInfo!: boolean
  @Prop({ default: 'text' }) type!: string
  @Prop({ default: null }) labelBackgroundColor!: string | null
  @Prop({ default: null }) inputFieldBackgroundColor!: string | null
  @Prop({ default: '' }) hintHtml!: string

  displayError = ''
  isFocused = false

  @Watch('error')
  onErrorChange () {
    this.displayError = this.error
  }

  mounted () {
    this.displayError = this.error
  }

  @Emit('input')
  updateValue(newValue: Event) {
    const input = newValue.target as HTMLInputElement
    return input.value
  }

  get state (): boolean | null {
    return this.displayError ? false : null
  }

  onFocus () {
    this.isFocused = true
    this.$emit('focus', this.value)
  }

  onKeyUpEnter () {
    this.$emit('keyupEnter', this.value)
  }

  onBlur (event: FocusEvent) {
    this.isFocused = false
    const input = event.target as HTMLInputElement
    this.$emit('blur', input.value)
  }
}
